import { makeStyles } from "@material-ui/core/styles";
import PassIcon from "../../../assets/images/football/pass-line.svg";
import GameControlIcon from "../../../assets/images/football/game-control.svg";
import ChangePossessionIcon from "../../../assets/images/football/change-possesion.svg";
import PenaltyIcon from "../../../assets/images/football/penalty.svg";
import PuntIcon from "../../../assets/images/football/punt.svg";
import RushIcon from "../../../assets/images/football/rush.svg";
import ParticipantsIcon from "../../../assets/images/football/participants.svg";

const icons = {
	pass: PassIcon,
	rush: RushIcon,
	punt: PuntIcon,
	patTry: ChangePossessionIcon,
	participants: ParticipantsIcon,
	penalty: PenaltyIcon,
	changePossession: ChangePossessionIcon,
	gameControl: GameControlIcon
};

const cardButtonIconStyles = makeStyles((theme) => ({
	icon: {
		color: theme.palette.gameMode.primary,
		minHeight: "100%",
		minWidth: "100%",
		backgroundSize: "3vw",
		backgroundRepeat: "no-repeat",
		backgroundPositionX: "right",
		backgroundPositionY: "bottom",
		backgroundImage: ({ iconName }) => `url(${icons[iconName]})`
	}
}));

export default cardButtonIconStyles;
